import React from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const markoknowFAQs = [
  {
    question: "What is Markoknow?",
    answer:
      "Markoknow is a learning and networking platform built for founders, startup enthusiasts, and learners. It helps users learn directly from experienced entrepreneurs, access startup resources, and grow their network.",
  },
  {
    question: "Who is Markoknow for?",
    answer:
      "Markoknow is ideal for early-stage founders, students, solopreneurs, product builders, investors, and anyone curious about starting or growing a startup.",
  },
  {
    question: "How do I join the Markoknow community?",
    answer:
      "Simply visit markoknow.com, sign up using your email, and start exploring courses, events, and forums.",
  },
  {
    question: "Is there a membership fee?",
    answer:
      "Many of our sessions are free, but premium mentorships or startup resources may come at a cost.",
  },
  {
    question: "What types of sessions are offered?",
    answer:
      "We offer workshops, founder talks, masterclasses, office hours, and AMA (Ask Me Anything) sessions covering startup building, fundraising, product, marketing, and more.",
  },
  {
    question: "How do I connect with other members?",
    answer:
      "You can interact via live chat during sessions, join our Slack/Discord, or participate in community threads and Q&As.",
  },
  {
    question: "Are events only online?",
    answer:
      "Currently, our sessions are online. In-person meetups and hackathons are in the works—stay tuned!",
  },
];

const MarkoknowFAQ = () => {
  return (
    <Box
      sx={{
        backgroundColor: "rgb(34, 24, 87)",
        color: "white",
        py: 8,
      }}
    >
      <Box
        sx={{
          mx: "auto",
          px: 3,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
          justifyContent: "center",
          width: "90%",
          gap: 4,
        }}
      >
        {/* Title Section */}
        <Box
          sx={{
            width: { xs: "100%", md: "40%" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              mb: 4,
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            Frequently Asked Questions
          </Typography>
        </Box>

        {/* FAQ Section */}
        <Box
          sx={{
            width: { xs: "100%", md: "60%" },
          }}
        >
          {markoknowFAQs.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "transparent",
                color: "white",
                boxShadow: "none",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                "&:before": { display: "none" },
                "&.Mui-expanded": { margin: 0 },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
              >
                <Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  sx={{ color: "rgba(255,255,255,0.8)", lineHeight: 1.6 }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default MarkoknowFAQ;
